import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { useDropzone } from 'react-dropzone';
import { RadioButton } from "primereact/radiobutton";

//icons
import BlackGallery from '../../assets/icons/black-gallery.svg'
import Gallery from '../../assets/icons/gallery.svg'
import Video from '../../assets/icons/video.svg'
import BlackVideo from '../../assets/icons/black-video.svg'
import Upload from '../../assets/icons/upload.svg'
import Info from '../../assets/icons/info.svg'
import Trash from '../../assets/icons/trash.svg'
import Img from '../../assets/images/image.jfif'
import './banner.css'
import { DeleteBanner, IsDefultBanner, baseUrl, CreateBanner, SearchBanner } from '../../utils/api';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import useToastNotification from '../../hooks/useToastNotification';
import { getRawBase64Data } from '../../utils/image';
import Loader from '../loader/loader'

function Banner({ slug }) {
    const { showError, showSuccess } = useToastNotification();
    const [visibleImageUpload, setVisibleImageUpload] = useState(false)
    const [visibleVideoUpload, setVisibleVideoUpload] = useState(false)
    const [videoNum, setVideoNum] = useState('')
    const [imageNum, setImageNum] = useState('')
    const [videoName, setVideoName] = useState('');
    const [imageName, setImageName] = useState('');
    const [uploadedFile, setUploadedFile] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const [videoPreview, setVideoPreview] = useState([]);
    const [uploadStatus, setUploadStatus] = useState(null);
    const [defaultImg, setDefaultImg] = useState('');
    const [status, setStatus] = useState(1);

    const [data, setData] = useState({});
    const [items, setItems] = useState([]);
    useEffect(() => {
        loadPage();
    }, []);
    const loadPage = async () => {
        try {
            SearchBanner({ slug }).then(response => {
                setData(response.data?.data);
                setItems(response.data?.data);
            })
        } catch (error) { }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (uploadedFile.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...imagePreview, ...newPreviews];
            setImagePreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

        },
        accept: 'image/*',  // Accept both images and videos
        maxFiles: 4
    });


    // Video upload
    const { getRootProps: getRootPropsVideo, getInputProps: getInputPropsVideo } = useDropzone({
        onDrop: (acceptedFiles) => {
            if (uploadedFile.length >= 4) {
                showError('حداکثر تعداد عکس ها 4 عدد است');
                return;
            }

            // Append new files
            const newFiles = acceptedFiles.slice(0, 4 - uploadedFile.length); // Limit to the remaining count
            const updatedFiles = [...uploadedFile, ...newFiles];
            setUploadedFile(updatedFiles);

            // Clear previews and set new previews
            const newPreviews = newFiles.map(file => URL.createObjectURL(file));
            let newPreviewsValue = [...videoPreview, ...newPreviews];
            setVideoPreview(newPreviewsValue);
            setDefaultImg(newPreviewsValue.length - 1);

        },
        accept: 'video/*',  // Accept both images and videos
        maxFiles: 4
    });

    const [loading, setLoading] = useState(false);
    const [addVisible, setAddVisible] = useState(false);

    const openAddDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setAddVisible(true);
    };
    const closeAddDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setAddVisible(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول

        // reset properties to default
        setImagePreview([]);
        setUploadedFile([]);
        setImageName('');
        setImageNum('');
    };


    const openVideoDialog = () => {
        setLoading(false);
        setUploadStatus("");
        setVisibleVideoUpload(true);
    };
    const closeVideoDialog = (forceClose = false) => {
        if (loading === true && forceClose !== true) return;
        setUploadStatus("");
        setVisibleVideoUpload(false);
        document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول


        // reset properties to default
        setVideoPreview([]);
        setUploadedFile([]);
        setImageName('');
        setImageNum('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            let data = {
                pageCode: slug,
                title: imageName,
                number: imageNum,
                type: 1,
                useFor: JSON.parse(status)
            };
            setLoading(true);
            for (let index = 0; index < uploadedFile.length; index++) {
                data["fileBase64"] = await getRawBase64Data(uploadedFile[index]);
                await CreateBanner(data)
                    .then(() => {
                        // showSuccess("عملیات با موفقیت انجام شد");
                    })
                    .catch(error => {
                        showError(error.response?.data?.message || 'خطایی رخ داد');
                    })
                    .finally();
            }
            loadPage();
            closeAddDialog();
        } catch (error) {
            showError(error.response?.data?.message || 'خطایی رخ داد');
        }
        finally {
            setLoading(false);
        }
    };


    const handleSubmitVideo = async (e) => {
        e.preventDefault();
        try {

            let data = {
                pageCode: slug,
                title: imageName,
                number: imageNum,
                type: 2,
                useFor: JSON.parse(status)
            };
            setLoading(true);
            for (let index = 0; index < uploadedFile.length; index++) {
                data["fileBase64"] = await getRawBase64Data(uploadedFile[index]);
                await CreateBanner(data)
                    .then(() => {
                        showSuccess("عملیات با موفقیت انجام شد");
                        setLoading(false);

                    })
                    .catch(error => {
                        showError(error.response?.data?.message || 'خطایی رخ داد');
                        setLoading(false);
                    })
                    .finally();
            }
            loadPage();
            closeVideoDialog();
        } catch (error) {
            showError(error.response?.data?.message || 'خطایی رخ داد');
        }
        finally {
            setLoading(false);
        }
    };

    //delete preview
    const handleRemoveFile = () => {
        setUploadedFile([]);
        setImagePreview([]);
        setVideoPreview([]);
    };


    const handleRemoveImage = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setImagePreview(prevPreviews => {
            const newPreviews = [...prevPreviews];
            newPreviews.splice(index, 1); // Remove the preview at the same index
            return newPreviews;
        });
    };

    const changeDefaultImage = async (selectedItem) => {
        try {
            // به‌روزرسانی موقت رابط کاربری
            const updatedItems = items.map((item) => ({
                ...item,
                isDefault: item.fileId === selectedItem.fileId,
            }));
            setItems(updatedItems);

            // ارسال درخواست به سرور
            await IsDefultBanner({ fileId: selectedItem.fileId, useFor: selectedItem.useFor });

            // بارگذاری مجدد داده‌ها در صورت نیاز
            await loadPage();
        } catch (error) {
            console.error('Error updating default image:', error);
        }
    };

    const deleteItem = async (item) => {
        await DeleteBanner({ id: item.id }).then(() => {
            showSuccess("عملیات با موفقیت انجام شد");
            loadPage();
        }).catch(error => {
            showError(error.response.data.message);
        });
    };

    const openDeleteDialog = async (rowData) => {
        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول

        confirmDialog({
            message: 'آیا از حذف آیتم اطمینان دارید؟',
            header: 'حذف آیتم',
            defaultFocus: 'reject',
            maskClassName: 'flex',
            headerClassName: '!pr-1 !pl-1',
            acceptClassName: 'btn btn-danger mx-1',
            rejectClassName: 'btn btn-secondary mx-1',
            acceptLabel: 'حذف',
            rejectLabel: 'انصراف',
            resizable: false,
            accept: () => {
                deleteItem(rowData)
                document.body.style.overflow = 'auto';
            },
            reject: () => {
                document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
            },
        });
    };


    // video
    const handleRemoveVideo = (index) => {
        setUploadedFile(prevFiles => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1); // Remove the file at the specified index
            return newFiles;
        });

        setVideoPreview(prevPreviews => {
            let newPreviews = [...prevPreviews];
            newPreviews = newPreviews.filter((_, i) => i !== index) // Remove the preview at the same index
            return newPreviews;
        });
    };
    return (
        <>
            <div className='d-flex align-items-center justify-content-start gap-3'>
                <div>
                    <div className='upload-file-btn' onClick={() => {
                        openAddDialog()
                        document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول
                    }}>
                        <img src={Gallery} alt="" />
                        <h6 className='fw-500 text-[#669D24] text-sm'>انتشار تصویر</h6>
                    </div>
                </div>
                <div className='upload-file-btn' onClick={() => {
                    setVisibleVideoUpload(true)
                    document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول
                }}>
                    <img src={Video} alt="" />
                    <h6 className='fw-500 text-[#669D24] text-sm'>انتشار ویدیو</h6>
                </div>
            </div>
            <h6 className='d-flex align-items-center gap-2 text-base font-bold mt-2'><img src={Info} />امکان آپلود چهار تصویر برای بنر وجود دارد.</h6>
            <hr />
            <div className='list-defult'>
                <h6 className='fw-500 d-flex align-items-center gap-2'><img src={BlackGallery} alt="" /> تصاویر و ویدئودسکتاپ</h6>
                {
                    items && items.filter(item => item.useFor === 1).length > 0 ? (
                        <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                            {items.filter(item => item.useFor === 1).map(item => (
                                <div className='upload-file-btn' key={item.id}>
                                    {item.typeId == 2 ? (
                                        <video
                                            src={baseUrl + 'io/' + item.filePath}
                                            // controls
                                            className="video-preview"
                                        />
                                    ) : (
                                        <img
                                            src={baseUrl + 'io/112x112/' + item.filePath}
                                            alt="Uploaded preview"
                                            className="image-preview"
                                        />
                                    )}
                                    <div className='upload-file-btn-bottom'>
                                        {item.typeId !== 2 && (
                                            <div className='d-flex align-items-center'>
                                                <RadioButton
                                                    inputId={`radio-${item.fileId}`}
                                                    value={item.fileId}
                                                    onChange={() => changeDefaultImage(item)}
                                                    checked={item.isDefault}
                                                />
                                                <label htmlFor={item.id} className="ml-2">پیش فرض</label>
                                            </div>
                                        )}
                                        <div>
                                            <img src={Trash} alt="" onClick={() => openDeleteDialog(item)} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : <p>هیچ تصویر دسکتاپی یافت نشد.</p>
                }

                <h6 className='fw-500 d-flex align-items-center gap-2 mt-5'><img src={BlackGallery} alt="" /> تصاویر و ویدئو موبایل</h6>
                {
                    items && items.filter(item => item.useFor === 2).length > 0 ? (
                        <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                            {items.filter(item => item.useFor === 2).map(item => (
                                <div className='upload-file-btn' key={item.id}>
                                    {item.typeId == 2 ? (
                                        <video
                                            src={baseUrl + 'io/112x112/' + item.filePath}
                                            
                                            className="video-preview"
                                            style={{ width: '100%', height: 'auto' }} // به طور کامل ویدئو را در کادر جا می‌دهد
                                        />
                                    ) : (
                                        <img
                                            src={baseUrl + 'io/112x112/' + item.filePath}
                                            alt="Uploaded preview"
                                            className="image-preview"
                                        />
                                    )}
                                    <div className='upload-file-btn-bottom'>
                                        {item.typeId !== 2 && (
                                            <div className='d-flex align-items-center'>
                                                <RadioButton
                                                    inputId={`radio-${item.fileId}`}
                                                    value={item.fileId}
                                                    onChange={() => changeDefaultImage(item)}
                                                    checked={item.isDefault}
                                                />
                                                <label htmlFor={item.id} className="ml-2">پیش فرض</label>
                                            </div>
                                        )}
                                        <div>
                                            <img src={Trash} alt="" onClick={() => openDeleteDialog(item)} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : <p>هیچ تصویر موبایلی یافت نشد.</p>
                }
            </div>




            {/* upload image  */}
            <Dialog header="انتشار تصویر" visible={addVisible} maximizable style={{ width: '40vw' }} onHide={() => { if (!addVisible) return; closeAddDialog() }}>
                <div className='dialog-body mx-4'>
                    <Form className='mt-3' onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>نام تصویر</Form.Label>
                            <Form.Control type="text" value={imageName} onChange={(e) => setImageName(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>شماره تصویر</Form.Label>
                            <Form.Control required type="number" value={imageNum} onChange={(e) => setImageNum(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.status">
                            <Form.Label>نوع</Form.Label>
                            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value={1}>دسکتاپ</option>
                                <option value={2}>موبایل</option>
                            </Form.Select>
                        </Form.Group>
                        <div {...getRootProps()} className="upload-box mt-4 mb-2 flex-1" style={{ borderRadius: '8px', minHeight: '112px', minWidth: '112px' }}>
                            <input {...getInputProps()} />

                            <div>
                                <img src={Upload} alt="" className='mx-auto' />
                                <p className='text-xs mt-2 font-medium'>تصویر مورد نظر را از این قسمت وارد کنید</p>
                                <h6 className='text-[10px]'>بهترین ابعاد: {status == 1 ? '1400 * 500' : '420 * 420'}</h6>
                                <h6 className='text-[10px]'>ماکزیمم حجم تصویر: ...</h6>
                            </div>

                        </div>
                        <div className='d-flex gap-2 align-items-center' style={{ flexWrap: 'wrap' }}>
                            {
                                imagePreview.length > 0 &&
                                <div className="image-preview-container d-flex gap-2" style={{ flexWrap: 'wrap' }}>
                                    {imagePreview.map((image, index) => (
                                        <div className='list-defult'>

                                            <div className='d-flex align-items-center gap-2 mt-4' style={{ flexWrap: 'wrap' }}>
                                                <div className='upload-file-btn'>
                                                    <img src={image} alt="Uploaded preview" className="image-preview" />
                                                    <div className='upload-file-btn-bottom'>
                                                        <div className='d-flex align-items-center' >
                                                            <RadioButton inputId={image} name="selected-images" value={index} onChange={(e) => setDefaultImg(e.value)} checked={defaultImg === index} />
                                                            <label htmlFor="ingredient1" className="ml-2">پیش فرض</label>

                                                        </div>
                                                        <div>
                                                            <img src={Trash} alt="" onClick={() => handleRemoveImage(index)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    ))}
                                </div>

                            }


                        </div>

                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>


            {/* upload video  */}
            <Dialog header="انتشار ویدیو" visible={visibleVideoUpload} maximizable style={{ width: '40vw' }} onHide={() => { if (!visibleVideoUpload) return; closeVideoDialog(); }}>
                <div className='dialog-body mx-4'>
                    <Form className='mt-3' onSubmit={handleSubmitVideo}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>نام ویدیو</Form.Label>
                            <Form.Control required type="text" value={imageName} onChange={(e) => setImageName(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>شماره ویدیو</Form.Label>
                            <Form.Control required type="number" value={imageNum} onChange={(e) => setImageNum(e.target.value)} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.status">
                            <Form.Label>نوع</Form.Label>
                            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value={1}>دسکتاپ</option>
                                <option value={2}>موبایل</option>
                            </Form.Select>
                        </Form.Group>

                        {/* Preview of videos */}
                        <div key={JSON.stringify(videoPreview)}>
                            {/* the key is set to refresh video previews after delete one */}
                            {(!!videoPreview && videoPreview.length > 0) &&
                                videoPreview.map((item, index) =>
                                    <div key={index} className="w-full mt-3 relative border-[1px] !border-[#45a049] border-dashed bg-[#ddd] p-3 rounded">
                                        <video controls className="video-preview w-full">
                                            <source src={item} type="video/mp4" />
                                            مرورگر شما از پخش ویدیو پشتیبانی نمی‌کند.
                                        </video>
                                        <div className='upload-file-btn-bottom'>
                                            <div className='d-flex align-items-center' >
                                                <RadioButton inputId={index} name="selected-images" value={index} onChange={(e) => setDefaultImg(e.value)} checked={defaultImg === index} />
                                                <label htmlFor="ingredient1" className="ml-2 px-1"> پیش فرض </label>

                                            </div>
                                            <div>
                                                <img src={Trash} alt="" onClick={() => handleRemoveVideo(index)} />
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>
                        <div {...getRootPropsVideo()} className="upload-box mt-3">
                            <input {...getInputPropsVideo()} accept='video/*' />
                            {
                                (
                                    <div>
                                        <img src={Upload} alt="" className='mx-auto' />
                                        <p className='text-xs mt-2 font-medium'>ویدیو مورد نظر را از این قسمت وارد کنید</p>

                                    </div>
                                )
                            }
                        </div>

                        {uploadStatus && <p className="upload-status">{uploadStatus}</p>}

                        <button type="submit" disabled={loading} className="btn btn-primary w-100 mt-4">تایید و ثبت {loading && <Loader />}</button>
                    </Form>
                </div>
            </Dialog>

        </>
    )
}
export default Banner;
